import Config from "@_configs/api.config";
import { authHeader, handleResponse } from "@_utils/helpers";
import fetch_helper from "@_utils/fetch_helper";
const fetch = fetch_helper.fetch;

export const lettersService = {
  downloadLetter,
};

function downloadLetter(caseId, letterId) {
  let url = Config.API_ROOT + `/cases/${caseId}/letter/${letterId}`;

  return fetch(url, {
    method: "GET",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
    },
  }).then(handleResponse);
}
